import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IGetTransferTraysParams } from '../../../types';

/**
 * This key is used to track useTransferTrayListQuery
 */
export const TRANSFER_TRAY_LIST_QUERY_KEY = 'transfer-tray-list-query-key';

/**
 * This hook fetches the tray list for a specific inventory transfer.
 */
export const useTransferTrayListQuery = (params: IGetTransferTraysParams) => {
  const { inventoryTransferId, limit = 30, page = 1, filter } = params;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    queryKey: [
      TRANSFER_TRAY_LIST_QUERY_KEY,
      inventoryTransferId,
      page,
      limit,
      filter,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: ({ pageParam = page }) =>
      INV_MGMT_SERVICE_API.getTransferTrays({
        inventoryTransferId,
        page: pageParam,
        limit,
        filter,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
